import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagHigh = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.90909 2.90912C2.40701 2.90912 2 3.31613 2 3.81821V20.1818C2 20.6839 2.40701 21.0909 2.90909 21.0909C3.41117 21.0909 3.81818 20.6839 3.81818 20.1818V14.9546H21.0909C21.3994 14.9546 21.6869 14.7981 21.8544 14.539C22.0219 14.2799 22.0465 13.9536 21.9199 13.6723L19.7856 8.93185L21.9199 4.19142C22.0465 3.9101 22.0219 3.58375 21.8544 3.32467C21.6869 3.06558 21.3994 2.90912 21.0909 2.90912H2.90909Z",
		fill: "#F05252"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.60192 12.85C9.14726 12.85 8.91992 12.6227 8.91992 12.168V5.83202C8.91992 5.37736 9.14726 5.15002 9.60192 5.15002H9.66792C10.1226 5.15002 10.3499 5.37736 10.3499 5.83202V8.13102H13.6389V5.83202C13.6389 5.37736 13.8663 5.15002 14.3209 5.15002H14.3979C14.8526 5.15002 15.0799 5.37736 15.0799 5.83202V12.168C15.0799 12.6227 14.8526 12.85 14.3979 12.85H14.3209C13.8663 12.85 13.6389 12.6227 13.6389 12.168V9.45103H10.3499V12.168C10.3499 12.6227 10.1226 12.85 9.66792 12.85H9.60192Z",
		fill: "#111928"
	})]
});
export default SvgFlagHigh;
